import apiClient from './client'
import type { CalendarResponse, CalendarQuery } from '@/types'

export const calendarApi = {
  getCalendar: async (assistantId: string, query: CalendarQuery): Promise<CalendarResponse> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/calendar`, { params: query })
    return data
  },
}
